// Croqui: `components/KV.tsx` (KV + KVGroup).

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';

export interface KVRow {
  k: string;
  v: ReactNode;
  monoV?: boolean;
}

/**
 * Chave à esquerda (muted), valor à direita. Sem fio entre as linhas, como o `KeyValue` do
 * lojista: quem separa é o grupo (`KVGroup`, `border-t` da seção), não cada par.
 */
export function KV({
  k,
  v,
  monoV = false,
  className,
}: {
  k: ReactNode;
  v: ReactNode;
  monoV?: boolean;
  /** Aceito por compatibilidade: não há mais fio entre as linhas pra tirar. */
  last?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('flex items-baseline justify-between gap-4 py-1.5 text-13', className)}>
      <span className="shrink-0 text-muted">{k}</span>
      <span
        className={cn(
          'min-w-0 break-words text-right font-medium text-text tabular-nums',
          monoV && 'font-mono',
        )}
      >
        {v}
      </span>
    </div>
  );
}

/** Seção de detalhe: título em eyebrow + linhas KV. */
export function KVGroup({
  title,
  rows,
  className,
}: {
  title?: string;
  rows: KVRow[];
  className?: string;
}) {
  return (
    <div className={className}>
      {title !== undefined && <div className="micro-label mb-1.5">{title}</div>}
      {rows.map((row) => (
        <KV key={row.k} k={row.k} v={row.v} monoV={row.monoV ?? false} />
      ))}
    </div>
  );
}
